import { Injectable } from "@angular/core";
import { SolarAccountEs, SolarAccountEsFactory } from "@edp-models/ES/es-solar-account.model";
import { SolarAccountEsService } from "@edp-services/ES/solar-account-es.service";
import {
    ESolarAccountEsActions,
    GetSolarAccountEs,
    SetAccountAPIError,
    SetSolarAccountEs,
} from "@edp-store/actions/ES/solar-account-es.actions";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";

@Injectable()
export class SolarAccountEsEffects {
    @Effect()
    loadAccount$ = this.actions$.pipe(
        ofType(ESolarAccountEsActions.GetSolarAccountEs),
        switchMap((action: GetSolarAccountEs) =>
            this.solarAccountEsService.get().pipe(
                mergeMap((account: SolarAccountEs) => of(new SetSolarAccountEs(SolarAccountEsFactory.create(account)))),
                catchError((error: Error) => of(new SetAccountAPIError(error)))
            )
        )
    );

    constructor(private actions$: Actions, private solarAccountEsService: SolarAccountEsService) {}
}
